export { default as PartDetails } from "./PartDetails.vue";
